import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import TRANSLATIONS_EN from './en.json';
import TRANSLATIONS_ES from './es.json';
import TRANSLATIONS_PT from './pt.json';

const resources = {
  en: {
    translation: TRANSLATIONS_EN,
  },
  es: {
    translation: TRANSLATIONS_ES,
  },
  pt: {
    translation: TRANSLATIONS_PT,
  },
};

const detectionOptions = {
  order: ['localStorage', 'cookie'],
  lookupLocalStorage: 'gs_lang_pref', // key for language in localStorage
  lookupCookie: 'gs_lang_pref', // key for language in cookies
  caches: ['localStorage', 'cookie'], // cache the language in both localStorage and cookies
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultLanguage: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    otherLanguages: ['en', 'es', 'pt'],
    detection: detectionOptions,
    react: {
      bindI18n: 'languageChanged',
      useSuspense: false,
    },
  });

export default i18n;
